// extracted by mini-css-extract-plugin
export default {"content":"Product_dev_content__hU82q","ref":"Product_dev_ref__bdU-1"};